<template>
  <div class='event-carousel' :style="'background:url('+ fondo +') no-repeat center center;'" @click="$router.push('/evento/' + evento.hash)">
    <div class="col-xs-12 hero-info">
      <div class='info-left col-xs-12'>
        <h3 class='hero-title'>
          {{evento.nombre}}
        </h3>
        <h4 class='hero-subtitle' v-html="$options.filters.truncate(evento.desc,150)"></h4>
        <h4 class='hero-location'>
          {{evento.descripcion.direccion}}
        </h4>
        <h5 class='hero-date'>
          {{evento.fecha_evento.end ?
            moment(evento.fecha_evento.start).isSame(evento.fecha_evento.end, 'day') ?
            moment(evento.fecha_evento.start).format('lll') :
            moment(evento.fecha_evento.start).format('ll') + ' - ' + moment(evento.fecha_evento.end).format('ll')
            : moment(evento.fecha_evento.start).format('lll')
          }}
        </h5>
      </div>
      <div class='info-right col-xs-12'>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import moment from 'moment'
export default {
  name: 'evento',
  props: ['evento'],
  mounted () {

  },
  data () {
    return {
      moment
      // fondo: urlApi + '/eventos/media/' + this.evento.hash
    }
  },
  methods: {

  },
  computed: {
    fondo () {
      let path = ''
      path = this.evento.media.url
      return path
    }
  }
}
</script>

<style scoped lang="scss">
.event-carousel {
  min-height: 320px;
  max-height: 320px;
  display: block;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center 40% !important;
  .hero-title {
    font-family: 'brandon_grotesquebold', sans-serif;
  }
  .hero-subtitle {
    font-family: 'brandon_grotesquelight_italic', sans-serif;
  }
  .hero-info {
    margin-top: 150px;
    padding: 25px 35px;
    color: aliceblue;
    background: -webkit-linear-gradient(-90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.95) 100%);
    .info-left {
      text-align: left;
    }
    .hero-date {
      margin-top: 15px;
      text-transform: lowercase;
      text-align: right;
    }
    .info-right {
      text-align: right;
      .hero-date {
        margin-bottom: 20px;
        text-transform: lowercase;
      }
    }
  }
}
</style>
